// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const UserList = () => {
//   const [formData, setFormData] = useState({
//     stock_name: "",
//     units: "",
//   });

//   const [stocks, setStocks] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [editMode, setEditMode] = useState(false);
//   const [selectedId, setSelectedId] = useState(null);
//   const [category, setcategory] = useState(null);
//   const [categoryNames, setCategoryNames] = useState({});

//   console.log(category);
//   const handleChange = (e) => {
//     setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   useEffect(() => {
//     fetchStocks();
//   }, []);
//   useEffect(() => {
//     fetchCategory();
//   }, []);

//   const fetchStocks = async () => {
//     try {
//       const response = await axios.get(
//         "https://ims-backend.indevconsultancy.in/api/stocks/"
//       );
//       console.log(response.data);
//       setStocks(response.data);

//       const uniqueCategoryIds = [
//         ...new Set(response.data.map((stock) => stock.category_id)),
//       ];

//       const categoryMap = {};
//       for (const id of uniqueCategoryIds) {
//         try {
//           console.log("Fetching category for ID:", id);
//           const res = await axios.post(
//             "https://ims-backend.indevconsultancy.in/api/category_name/",
//             { category_id: String(id) },
//             { headers: { "Content-Type": "application/json" } }
//           );
//           categoryMap[id] = res.data.category_name;
//         } catch (err) {
//           console.error(
//             "Failed for ID:",
//             id,
//             err.response?.data || err.message
//           );
//         }
//       }

//       setCategoryNames(categoryMap);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching stocks:", error);
//       setLoading(false);
//     }
//   };

//   const fetchCategory = async () => {
//     try {
//       const response = await axios.get(
//         "https://ims-backend.indevconsultancy.in/admin-panel/category/"
//       );
//       setcategory(response.data);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching stocks:", error);
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!formData.stock_name || !formData.units) {
//       alert("Please fill in Item Name and Unit.");
//       return;
//     }

//     try {
//       if (editMode) {
//         await axios.put(
//           `https://ims-backend.indevconsultancy.in/api/stocks/${selectedId}/`,
//           formData
//         );
//         alert("Item updated successfully!");
//       } else {
//         await axios.post(
//           "https://ims-backend.indevconsultancy.in/api/stocks/",
//           formData
//         );
//         alert("Item added successfully!");
//       }

//       fetchStocks();
//     } catch (error) {
//       console.error("Error saving item:", error);
//       alert("Failed to save item");
//     }

//     setFormData({ stock_name: "", units: "", category_id: "" });
//     setEditMode(false);
//     setSelectedId(null);

//     const modal = document.getElementById("registerModal");
//     if (modal) {
//       const modalInstance = window.bootstrap.Modal.getInstance(modal);
//       modalInstance.hide();
//     }
//   };

//   const handleEdit = (item) => {
//     setFormData({ stock_name: item.stock_name, units: item.units });
//     setSelectedId(item.stock_id);
//     setEditMode(true);
//     const modal = new window.bootstrap.Modal(
//       document.getElementById("registerModal")
//     );
//     modal.show();
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this item?")) {
//       try {
//         await axios.delete(
//           `https://ims-backend.indevconsultancy.in/api/stocks/${id}/`
//         );
//         alert("Item deleted successfully!");
//         fetchStocks();
//       } catch (error) {
//         console.error("Error deleting item:", error);
//         alert("Failed to delete item.");
//       }
//     }
//   };

//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const totalPages = Math.ceil(stocks.length / itemsPerPage);
//   const paginatedList = stocks.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   console.log(categoryNames);

//   return (
//     <>
//       <div className="content">
//         <div className="container-fluid">
//           <div className="row g-3">
//             <div className="col-md-12">
//               <div className="card">
//                 <div className="card-header border-info">
//                   <form>
//                     <div className="row g-3">
//                       <div className="col-lg">
//                         <select name="state" className="form-select">
//                           <option value="">Select Items</option>
//                           {stocks.map((item, i) => (
//                             <option key={i} value={item.stock_id}>
//                               {item.stock_name}
//                             </option>
//                           ))}
//                         </select>
//                       </div>

//                       <div className="col-lg-2">
//                         <button type="submit" className="btn btn-primary w-100">
//                           Search
//                         </button>
//                       </div>
//                       <div className="col-lg-1">
//                         <a href="#" className="btn btn-outline-dark w-100">
//                           Reset
//                         </a>
//                       </div>
//                     </div>
//                   </form>
//                 </div>

//                 <div className="card-body">
//                   <div className="row g-0 align-items-center">
//                     <div className="col-sm-7 mb-3">
//                       <h6 className="fw-bold mb-0">
//                         Total Item(s): <span>{stocks.length}</span>
//                       </h6>
//                     </div>
//                     <div className="col-sm-5 mb-3 text-end">
//                       <button
//                         className="btn btn-primary"
//                         data-bs-toggle="modal"
//                         data-bs-target="#registerModal"
//                         onClick={() => {
//                           setFormData({ stock_name: "", units: "" });
//                           setEditMode(false);
//                           setSelectedId(null);
//                         }}
//                       >
//                         Add Item
//                       </button>
//                     </div>
//                   </div>

//                   <div className="table-responsive scrollbar">
//                     <table className="table text-center table-bordered table-striped fs--1 mb-0">
//                       <thead className="bg-primary text-white">
//                         <tr>
//                           <th>S.No.</th>
//                           <th>Category Name</th>
//                           <th>Item Name</th>
//                           <th>Unit</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {loading ? (
//                           <tr>
//                             <td colSpan="4">Loading...</td>
//                           </tr>
//                         ) : stocks.length === 0 ? (
//                           <tr>
//                             <td colSpan="4">No items found.</td>
//                           </tr>
//                         ) : (
//                           // stocks.map((item, i) => (
//                           //   <tr key={item.stock_id}>
//                           //     <td>{i + 1}</td>
//                           //     <td>{categoryNames[item.category_id]}</td>
//                           //     <td>{item.stock_name}</td>
//                           //     <td>{item.units}</td>
//                           //     <td>
//                           //       <button
//                           //         className="btn btn-sm btn-warning me-2"
//                           //         onClick={() => handleEdit(item)}
//                           //       >
//                           //         Edit
//                           //       </button>
//                           //       <button
//                           //         className="btn btn-sm btn-danger"
//                           //         onClick={() => handleDelete(item.stock_id)}
//                           //       >
//                           //         Delete
//                           //       </button>
//                           //     </td>
//                           //   </tr>
//                           // ))
//                           paginatedList.map((item, i) => (
//                             <tr key={item.stock_id}>
//                               <td>
//                                 {(currentPage - 1) * itemsPerPage + i + 1}
//                               </td>
//                               <td>{categoryNames[item.category_id]}</td>
//                               <td>{item.stock_name}</td>
//                               <td>{item.units}</td>
//                               <td>
//                                 <button
//                                   className="btn btn-sm text-white me-2"
//                                    style={{background:"#28a745"}}
//                                   onClick={() => handleEdit(item)}
//                                 >
//                                   Edit
//                                 </button>
//                                 <button
//                                   className="btn btn-sm text-white"
//                                   style={{background:"#8b1a1a"}}
//                                   onClick={() => handleDelete(item.stock_id)}
//                                 >
//                                   Delete
//                                 </button>
//                               </td>
//                             </tr>
//                           ))
//                         )}
//                       </tbody>
//                     </table>
//                   </div>

//                   <div className="d-flex justify-content-between align-items-center mt-3">
//                     <button
//                       className="btn btn-outline-primary btn-sm"
//                       onClick={() =>
//                         setCurrentPage((prev) => Math.max(prev - 1, 1))
//                       }
//                       disabled={currentPage === 1}
//                     >
//                       Previous
//                     </button>
//                     <span>
//                       Page {currentPage} of {totalPages}
//                     </span>
//                     <button
//                       className="btn btn-outline-primary btn-sm"
//                       onClick={() =>
//                         setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//                       }
//                       disabled={currentPage === totalPages}
//                     >
//                       Next
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Modal */}
//       <div
//         className="modal fade"
//         id="registerModal"
//         tabIndex="-1"
//         aria-labelledby="registerModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog modal-lg">
//           <div className="modal-content">
//             <form onSubmit={handleSubmit}>
//               <div className="modal-header">
//                 <h5 className="modal-title" id="registerModalLabel">
//                   {editMode ? "Edit Item" : "Add Item"}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   data-bs-dismiss="modal"
//                   aria-label="Close"
//                 ></button>
//               </div>

//               <div className="modal-body">
//                 <div className="row g-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Category Name</label>
//                     <select
//                       name="category_id"
//                       className="form-select"
//                       value={formData.category_id}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select Category</option>
//                       {category &&
//                         category.map((item, i) => (
//                           <option key={i} value={item.category_id}>
//                             {item.category_name}
//                           </option>
//                         ))}
//                     </select>
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label">Item Name</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="stock_name"
//                       value={formData.stock_name}
//                       onChange={handleChange}
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label">Unit</label>
//                     <select
//                       name="units"
//                       className="form-select"
//                       value={formData.units}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select Unit</option>
//                       <option value="kg">kg</option>
//                       <option value="gram">gram</option>
//                       <option value="liter">liter</option>
//                       <option value="ml">ml</option>
//                       <option value="packets">packets</option>
//                       <option value="units">units</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   data-bs-dismiss="modal"
//                 >
//                   Close
//                 </button>
//                 <button type="submit" className="btn btn-primary">
//                   {editMode ? "Update Item" : "Save Item"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default UserList;

import React, { useState, useEffect } from "react";
import axios from "axios";

const UserList = () => {
  const [formData, setFormData] = useState({
    stock_code: "",
    stock_name: "",
    units: "",
    category_id: "",
  });

  const [stocks, setStocks] = useState([]);
  const [filteredStocks, setFilteredStocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [category, setcategory] = useState(null);
  const [categoryNames, setCategoryNames] = useState({});
  const [searchId, setSearchId] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // Auto-generate item code = category's first letter + next 3-digit sequence
  // for that letter (e.g. Vegetables -> V001, V002 ...).
  const generateCode = (categoryId) => {
    if (!categoryId) return "";
    const cat = (category || []).find(
      (c) => String(c.category_id) === String(categoryId)
    );
    const name = (cat?.category_name || "").trim();
    const letter = (name[0] || "").toUpperCase();
    if (!letter) return "";

    const re = new RegExp(`^${letter}(\\d+)$`, "i");
    let max = 0;
    stocks.forEach((s) => {
      const m = (s.stock_code || "").match(re);
      if (m) {
        const n = parseInt(m[1], 10);
        if (n > max) max = n;
      }
    });
    return letter + String(max + 1).padStart(3, "0");
  };

  // When category changes, auto-fill the code (only while ADDING — never
  // overwrite an existing item's code during edit).
  const handleCategoryChange = (e) => {
    const categoryId = e.target.value;
    setFormData((prev) => ({
      ...prev,
      category_id: categoryId,
      stock_code: editMode ? prev.stock_code : generateCode(categoryId),
    }));
  };

  useEffect(() => {
    fetchStocks();
  }, []);
  useEffect(() => {
    fetchCategory();
  }, []);

  const fetchStocks = async () => {
    try {
      const response = await axios.get(
        "https://ims-backend.indevconsultancy.in/api/stocks/"
      );
      setStocks(response.data);

      const uniqueCategoryIds = [
        ...new Set(response.data.map((stock) => stock.category_id)),
      ];

      const categoryMap = {};
      for (const id of uniqueCategoryIds) {
        try {
          const res = await axios.post(
            "https://ims-backend.indevconsultancy.in/api/category_name/",
            { category_id: String(id) },
            { headers: { "Content-Type": "application/json" } }
          );
          categoryMap[id] = res.data.category_name;
        } catch (err) {
          console.error(
            "Failed for ID:",
            id,
            err.response?.data || err.message
          );
        }
      }

      setCategoryNames(categoryMap);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching stocks:", error);
      setLoading(false);
    }
  };

  const fetchCategory = async () => {
    try {
      const response = await axios.get(
        "https://ims-backend.indevconsultancy.in/admin-panel/category/"
      );
      setcategory(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching stocks:", error);
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.stock_name || !formData.units) {
      alert("Please fill in Item Name and Unit.");
      return;
    }

    try {
      if (editMode) {
        await axios.put(
          `https://ims-backend.indevconsultancy.in/api/stocks/${selectedId}/`,
          formData
        );
        alert("Item updated successfully!");
      } else {
        await axios.post(
          "https://ims-backend.indevconsultancy.in/api/stocks/",
          formData
        );
        alert("Item added successfully!");
      }

      fetchStocks();
    } catch (error) {
      console.error("Error saving item:", error);
      alert("Failed to save item");
    }

    setFormData({ stock_code: "", stock_name: "", units: "", category_id: "" });
    setEditMode(false);
    setSelectedId(null);

    const modal = document.getElementById("registerModal");
    if (modal) {
      const modalInstance = window.bootstrap.Modal.getInstance(modal);
      modalInstance.hide();
    }
  };

  const handleEdit = (item) => {
    setFormData({
      stock_code: item.stock_code || "",
      stock_name: item.stock_name,
      units: item.units,
      category_id: item.category_id,
    });
    setSelectedId(item.stock_id);
    setEditMode(true);
    const modal = new window.bootstrap.Modal(
      document.getElementById("registerModal")
    );
    modal.show();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      try {
        await axios.delete(
          `https://ims-backend.indevconsultancy.in/api/stocks/${id}/`
        );
        alert("Item deleted successfully!");
        fetchStocks();
      } catch (error) {
        console.error("Error deleting item:", error);
        alert("Failed to delete item.");
      }
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const dataToDisplay = filteredStocks.length > 0 ? filteredStocks : stocks;
  const totalPages = Math.ceil(dataToDisplay.length / itemsPerPage);
  const paginatedList = dataToDisplay.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleExportCSV = () => {
    if (!dataToDisplay || dataToDisplay.length === 0) {
      alert("No items to export.");
      return;
    }
    const headers = ["S.No.", "Item Code", "Category Name", "Item Name", "Unit"];
    const escape = (v) => {
      const s = (v == null ? "" : String(v)).replace(/\r?\n|\r/g, " ");
      return /[",]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    };
    const rows = dataToDisplay.map((item, i) => [
      i + 1,
      item.stock_code || "",
      categoryNames[item.category_id] || "",
      item.stock_name || "",
      item.units || "",
    ]);
    const csv = [headers, ...rows].map((r) => r.map(escape).join(",")).join("\n");
    // UTF-8 BOM so Excel renders Unicode item names correctly.
    const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "item_list.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <div className="row g-3">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header border-info">
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (searchId) {
                        const filtered = stocks.filter(
                          (item) => item.stock_id === parseInt(searchId)
                        );
                        setFilteredStocks(filtered);
                        setCurrentPage(1);
                      } else {
                        setFilteredStocks([]);
                      }
                    }}
                  >
                    <div className="row g-3">
                      <div className="col-lg">
                        <select
                          name="state"
                          className="form-select"
                          value={searchId}
                          onChange={(e) => setSearchId(e.target.value)}
                        >
                          <option value="">Select Items</option>
                          {stocks.map((item, i) => (
                            <option key={i} value={item.stock_id}>
                              {item.stock_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-lg-2">
                        <button type="submit" className="btn btn-primary w-100">
                          Search
                        </button>
                      </div>
                      <div className="col-lg-1">
                        <a
                          href="#"
                          className="btn btn-outline-dark w-100"
                          onClick={(e) => {
                            e.preventDefault();
                            setSearchId("");
                            setFilteredStocks([]);
                          }}
                        >
                          Reset
                        </a>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="card-body">
                  <div className="row g-0 align-items-center">
                    <div className="col-sm-7 mb-3">
                      <h6 className="fw-bold mb-0">
                        Total Item(s): <span>{dataToDisplay.length}</span>
                      </h6>
                    </div>
                    <div className="col-sm-5 mb-3 text-end">
                      <button
                        className="btn btn-success me-2"
                        onClick={handleExportCSV}
                      >
                        <i className="fas fa-file-csv"></i> Export CSV
                      </button>
                      <button
                        className="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#registerModal"
                        onClick={() => {
                          setFormData({
                            stock_code: "",
                            stock_name: "",
                            units: "",
                            category_id: "",
                          });
                          setEditMode(false);
                          setSelectedId(null);
                        }}
                      >
                        Add Item
                      </button>
                    </div>
                  </div>

                  <div className="table-responsive scrollbar">
                    <table className="table text-center table-bordered table-striped fs--1 mb-0">
                      <thead className="bg-primary text-white">
                        <tr>
                          <th>S.No.</th>
                          <th>Item Code</th>
                          <th>Category Name</th>
                          <th>Item Name</th>
                          <th>Unit</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="6">Loading...</td>
                          </tr>
                        ) : dataToDisplay.length === 0 ? (
                          <tr>
                            <td colSpan="6">No items found.</td>
                          </tr>
                        ) : (
                          paginatedList.map((item, i) => (
                            <tr key={item.stock_id}>
                              <td>
                                {(currentPage - 1) * itemsPerPage + i + 1}
                              </td>
                              <td>{item.stock_code || "-"}</td>
                              <td>{categoryNames[item.category_id]}</td>
                              <td>{item.stock_name}</td>
                              <td>{item.units}</td>
                              <td>
                                <button
                                  className="btn btn-sm text-white me-2"
                                  style={{ background: "#28a745" }}
                                  onClick={() => handleEdit(item)}
                                >
                                  Edit
                                </button>
                                <button
                                  className="btn btn-sm text-white"
                                  style={{ background: "#8b1a1a" }}
                                  onClick={() => handleDelete(item.stock_id)}
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                    <span>
                      Page {currentPage} of {totalPages}
                    </span>
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() =>
                        setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                      }
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="registerModal"
        tabIndex="-1"
        aria-labelledby="registerModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title" id="registerModalLabel">
                  {editMode ? "Edit Item" : "Add Item"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="row g-3">
                <div className="col-md-6">
                    <label className="form-label">Item Code</label>
                    <input
                      type="text"
                      className="form-control"
                      name="stock_code"
                      placeholder=""
                      value={formData.stock_code}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Category Name</label>
                    <select
                      name="category_id"
                      className="form-select"
                      value={formData.category_id}
                      onChange={handleCategoryChange}
                    >
                      <option value="">Select Category</option>
                      {category &&
                        category.map((item, i) => (
                          <option key={i} value={item.category_id}>
                            {item.category_name}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Item Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="stock_name"
                      value={formData.stock_name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Unit</label>
                    <select
                      name="units"
                      className="form-select"
                      value={formData.units}
                      onChange={handleChange}
                    >
                      <option value="">Select Unit</option>
                      <option value="kg">kg</option>
                      <option value="gram">gram</option>
                      <option value="liter">liter</option>
                      <option value="ml">ml</option>
                      <option value="packets">packets</option>
                      <option value="units">units</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  {editMode ? "Update Item" : "Save Item"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserList;
